import { ResetMemberPasswordErrorCodeV1, ResetMemberPasswordErrorV1 } from '@vista-digital/ocapi-client';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { CommonErrorCodes } from '../../../../../types/errors/common-error-codes';
import { logger } from '../../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../../utils/validators/string';
import { LoyaltyDomainError, LoyaltyDomainSpecificErrorCode } from '../../../types/error';
export const resetMemberPassword = async (password, resetCode) => {
    if (!nonEmptyStringValidator(resetCode, logger.error, 'resetPassword')) {
        throw new Error('Cannot reset password without a reset code');
    }
    if (!nonEmptyStringValidator(password, logger.error, 'resetPassword')) {
        throw new Error('Cannot reset password without a password');
    }
    const request = { resetCode, password };
    try {
        await ocapiClient.instance.v1.loyalty.members.passwordReset.reset(request);
    }
    catch (error) {
        throw handleResetPasswordError(error);
    }
};
const handleResetPasswordError = (error) => {
    if (!(error instanceof ResetMemberPasswordErrorV1))
        throw error; // Unexpected error, rethrow immediately
    const errorCode = convertApiToDomainErrorCode(error.errorCode);
    return new LoyaltyDomainError(errorCode, error.message);
};
const convertApiToDomainErrorCode = (errorCode) => {
    switch (errorCode) {
        case ResetMemberPasswordErrorCodeV1.PasswordKnownCompromised:
            return LoyaltyDomainSpecificErrorCode.PasswordKnownCompromised;
        case ResetMemberPasswordErrorCodeV1.PasswordContainsDisallowedWords:
            return LoyaltyDomainSpecificErrorCode.PasswordContainsDisallowedWords;
        case ResetMemberPasswordErrorCodeV1.PasswordContainsEmail:
            return LoyaltyDomainSpecificErrorCode.PasswordContainsEmail;
        case ResetMemberPasswordErrorCodeV1.PasswordContainsGivenOrSurname:
            return LoyaltyDomainSpecificErrorCode.PasswordContainsGivenOrSurname;
        case ResetMemberPasswordErrorCodeV1.PasswordContainsUsername:
            return LoyaltyDomainSpecificErrorCode.PasswordContainsUsername;
        case ResetMemberPasswordErrorCodeV1.PasswordMaximumLengthExceeded:
            return LoyaltyDomainSpecificErrorCode.PasswordMaximumLengthExceeded;
        case ResetMemberPasswordErrorCodeV1.PasswordMinimumNumericCharactersNotMet:
            return LoyaltyDomainSpecificErrorCode.PasswordMinimumNumericCharactersNotMet;
        case ResetMemberPasswordErrorCodeV1.PasswordMinimumDistinctCharactersNotMet:
            return LoyaltyDomainSpecificErrorCode.PasswordMinimumDistinctCharactersNotMet;
        case ResetMemberPasswordErrorCodeV1.PasswordMinimumLengthNotMet:
            return LoyaltyDomainSpecificErrorCode.PasswordMinimumLengthNotMet;
        case ResetMemberPasswordErrorCodeV1.PasswordMinimumNonNumericCharactersNotMet:
            return LoyaltyDomainSpecificErrorCode.PasswordMinimumNonNumericCharactersNotMet;
        case ResetMemberPasswordErrorCodeV1.PasswordResetCodeInvalid:
            return LoyaltyDomainSpecificErrorCode.PasswordResetCodeInvalid;
        default:
            return CommonErrorCodes.UnknownError;
    }
};
